export interface Region {
    name: string;
    imageUrl: string | null;
}

export interface Market {
    market: string;
    regions: Region[];
    state: string;
    imageUrl: string | null;
    imageUrlRoot: string;
    latitude: number;
    longitude: number;
}

export const MARKETS: Market[] = [
    {
        market: 'Northern California',
        regions: [
            {
                name: 'Napa/Sonoma',
                imageUrl: 'images/landing/regions/napa_valley/napa-valley-splash-landscape.jpg',
            },
            {
                name: 'San Francisco',
                imageUrl: 'images/landing/regions/san_francisco/san-francisco-splash-landscape.jpg',
            },
            {
                name: 'East Bay',
                imageUrl: 'images/venues/697/Vizcaya-Sacramento-CA-dea11932-d04d-4dea-9de4-ab96dd8ff476_thumbnail.1530210680.jpg',
            },
            {
                name: 'South Bay',
                imageUrl:
                    'images/venues/71/Cinnabar-Hills-Golf-Club-San-Jose-CA-67ad05a8-b5f1-4d21-864f-819ce4f01658_thumbnail.1568331555.jpg',
            },
            {
                name: 'Sacramento',
                imageUrl: 'images/venues/697/Vizcaya-Sacramento-CA-dea11932-d04d-4dea-9de4-ab96dd8ff476_thumbnail.1530210680.jpg',
            },
            {
                name: 'Monterey/Carmel Valley',
                imageUrl: 'images/landing/regions/monterey/monterey-splash-landscape.jpg',
            },
            {
                name: 'Peninsula',
                imageUrl: 'images/markets/Northern+California/Bay+Area/Kohl-Mansion-Wedding-Burlingame-CA-5-thumbnail.jpg',
            },
            {
                name: 'Redding',
                imageUrl:
                    'images/venues/10374/The-Falls-Event-Center,-Elk-Grove,-CA-wedding-Elk-Grove-CA-187263-orig_thumbnail.1503527649.jpg',
            },
            {
                name: 'Yosemite',
                imageUrl:
                    'images/venues/11148/Convict-Lake-Resort-Mammoth-Lakes-CA-25442a62-6f7a-4bf2-a8c3-16d76c2911f5_thumbnail.1578946178.jpg',
            },
            {
                name: 'Mendocino',
                imageUrl: 'images/venues/16468/Agate-Cove-Inn-MENDOCINO-CA-4a3dd4ed-d4ca-4563-be64-d1b361d0216f_thumbnail.1579794927.png',
            },
            {
                name: 'Tahoe',
                imageUrl: 'images/venues/444/Heavenly-Wedding-Tahoe-CA-6_thumbnail.1394506493.jpg',
            },
            {
                name: 'North Coast',
                imageUrl: 'images/venues/14684/Switzer-Farm-Westport-CA-815a84dd-b170-40f0-a2e9-125229358302_thumbnail.1548978939.jpg',
            },
            {
                name: 'Northern Lakes',
                imageUrl: 'images/venues/3681/Lassen-Meadows-Ranch-Wedding-Chester-CA-14_thumbnail.1431994017.jpg',
            },
            {
                name: 'Marin',
                imageUrl: 'images/venues/9/Corinthian-Yacht-Club-Tiburon-CA-91a267a1-5eb6-4226-a165-980c7fe1eca3_thumbnail.1570654000.jpg',
            },
            {
                name: 'Central Valley',
                imageUrl:
                    'images/venues/632/Harris-Ranch-Inn---Restaurant-Coalinga-CA-68aaa1c9-d965-4a20-8ff9-23059edf3558_thumbnail.1578682343.jpg',
            },
        ],
        state: 'CA',
        imageUrl: 'images/landing/markets/bay_area/bay-area-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 37.784562,
        longitude: -122.407315,
    },
    {
        market: 'Nevada',
        regions: [
            {
                name: 'Las Vegas',
                imageUrl: 'images/landing/regions/las_vegas/las-vegas-splash-landscape.jpg',
            },
            {
                name: 'Lake Tahoe',
                imageUrl: 'images/landing/regions/lake_tahoe/lake-tahoe-splash-landscape.jpg',
            },
            {
                name: 'Reno',
                imageUrl: 'images/landing/regions/reno/reno-splash-landscape.jpg',
            },
            {
                name: 'Elko',
                imageUrl: 'images/venues/11607/Red-Lion-Hotel-&-Casino-Wedding-Elko-NV-2_thumbnail.1492223910.jpg',
            },
        ],
        state: 'NV',
        imageUrl: 'images/landing/markets/nevada/nevada-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        latitude: 39.12088,
        longitude: -116.67498,
    },
    {
        market: 'Southern California',
        regions: [
            {
                name: 'Los Angeles',
                imageUrl: 'images/landing/regions/los_angeles/los-angeles-splash-landscape.jpg',
            },
            {
                name: 'San Diego',
                imageUrl: 'images/landing/regions/san_diego/san-diego-splash-landscape.jpg',
            },
            {
                name: 'Orange County',
                imageUrl: 'images/landing/regions/orange_county/orange-county-splash-landscape.jpg',
            },
            {
                name: 'Central Coast',
                imageUrl:
                    'images/venues/16518/La-Lomita-Ranch-San-Luis-Obispo-CA-7a259547-3369-4242-a94e-56bbe0d39027_thumbnail.1578341413.jpg',
            },
            {
                name: 'Santa Barbara',
                imageUrl: 'images/landing/regions/santa_barbara/santa-barbara-splash-landscape.jpg',
            },
            {
                name: 'Palm Springs',
                imageUrl:
                    'images/venues/448/Indian-Wells-Golf-Resort-Indian-Wells-CA-66ca20eb-cbd8-41ac-b8f7-aa00ab5eb543_thumbnail.1575916120.jpg',
            },
            {
                name: 'Inland Empire',
                imageUrl: 'images/venues/1079/Glen-Ivy-Golf-Corona-CA-fee523b4-4563-4bf1-800f-8dca9a799769_thumbnail.1576894246.jpg',
            },
            {
                name: 'Catalina Island',
                imageUrl: 'images/venues/1360/Hotel-Metropole-Avalon-CA-5_thumbnail.1417470415.jpg',
            },
        ],
        state: 'CA',
        imageUrl: 'images/landing/markets/southern_california/socal-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        latitude: 34.052234,
        longitude: -118.243684,
    },
    {
        market: 'Oregon',
        regions: [
            {
                name: 'Portland',
                imageUrl: 'images/landing/regions/portland/portland-splash-landscape.jpg',
            },
            {
                name: 'Willamette Valley',
                imageUrl: 'images/landing/regions/willamette_valley/willamette-valley-splash-landscape.jpg',
            },
            {
                name: 'Southern Oregon',
                imageUrl: 'images/venues/13826/Pelton-Vacation-Rental-Wedding-Ashland-OR-6_thumbnail.1504290514.jpg',
            },
            {
                name: 'Coastal Oregon',
                imageUrl: 'images/venues/16526/SeaWinds-Estate-Bandon-OR-31113614-e447-47d9-8a11-67e1e8fb2b16_thumbnail.1582664877.jpg',
            },
            {
                name: 'Mt. Hood',
                imageUrl: 'images/venues/14346/Mt-Hood-Meadows-Wedding-Mt-Hood-OR-32_thumbnail.1511807281.jpg',
            },
            {
                name: 'Eastern Oregon',
                imageUrl: 'images/venues/7144/Pendleton-Center-for-the-Arts-Wedding-Pendleton-OR-12_thumbnail.1451923535.jpg',
            },
        ],
        state: 'OR',
        imageUrl: 'images/landing/markets/oregon/oregon-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        latitude: 45.523031,
        longitude: -122.677339,
    },
    {
        market: 'Utah',
        regions: [
            {
                name: 'Salt Lake City',
                imageUrl: 'images/landing/regions/salt_lake_city/salt-lake-city-splash-landscape.jpg',
            },
            {
                name: 'South Utah',
                imageUrl:
                    'images/venues/16437/Escalante-Cliff-House-Escalante-UT-88726938-829c-48e0-b00e-b06b7ebbc3f5_thumbnail.1582135844.jpg',
            },
            {
                name: 'Central Utah',
                imageUrl: 'images/venues/7594/Sorrel-River-Ranch-Resort-&-Spa-Wedding-Moab-UT-2_thumbnail.1454051641.jpg',
            },
        ],
        state: 'UT',
        imageUrl: 'images/landing/markets/utah/utah-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        latitude: 39.321508,
        longitude: -111.645905,
    },
    {
        market: 'Idaho',
        regions: [
            {
                name: 'Idaho',
                imageUrl:
                    'images/venues/12329/Coeur-d-Alene-Casino-Resort-Worley-ID-9f9c1872-695c-48db-b7f9-5994570ca42a_thumbnail.1562966188.jpg',
            },
        ],
        state: 'ID',
        imageUrl: 'images/venues/12329/Coeur-d-Alene-Casino-Resort-Worley-ID-9f9c1872-695c-48db-b7f9-5994570ca42a_thumbnail.1562966188.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        latitude: 44.766013,
        longitude: -114.603856,
    },
    {
        market: 'Arizona',
        regions: [
            {
                name: 'Tucson',
                imageUrl: 'images/landing/regions/tucson/tucson-splash-landscape.jpg',
            },
            {
                name: 'Sedona/Flagstaff',
                imageUrl: 'images/venues/16491/Enchantment-Resort-Sedona-AZ-aabd22d6-5baf-4245-b78a-f030774235d1_thumbnail.1576853688.png',
            },
            {
                name: 'Western Arizona',
                imageUrl: 'images/venues/12387/El-Rio-Golf-Club-Wedding-Phoenix-AZ-4_thumbnail.1495735307.jpg',
            },
            {
                name: 'Phoenix/Scottsdale',
                imageUrl: 'images/landing/regions/phoenix/phoenix-splash-landscape.jpg',
            },
        ],
        state: 'AZ',
        imageUrl: 'images/landing/markets/arizona/arizona-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        latitude: 34.476649,
        longitude: -111.533674,
    },
    {
        market: 'Washington',
        regions: [
            {
                name: 'Seattle',
                imageUrl: 'images/landing/regions/seattle/seattle-splash-landscape.jpg',
            },
            {
                name: 'Everett',
                imageUrl: 'images/landing/regions/everett/everett-splash-landscape.jpg',
            },
            {
                name: 'Tacoma',
                imageUrl: 'images/landing/regions/tacoma/tacoma-splash-landscape.jpg',
            },
            {
                name: 'Yakima',
                imageUrl:
                    'images/venues/16509/Abeja-Winery---Inn-Walla-Walla-WA-224d7dfd-c656-424e-bead-8dc990013754_thumbnail.1578329889.jpg',
            },
            {
                name: 'Spokane',
                imageUrl:
                    'images/venues/16615/Montvale-Event-Center-Spokane-WA-dbd6f533-a1b7-4742-984f-c39a99d593ce_thumbnail.1588205097.jpg',
            },
        ],
        state: 'WA',
        imageUrl: 'images/landing/markets/washington_dc/washington-dc-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        latitude: 47.600497,
        longitude: -122.334469,
    },
    {
        market: 'Wyoming',
        regions: [
            {
                name: 'Wyoming',
                imageUrl: 'images/venues/14826/Snow-King-Hotel-Wedding-Jackson-WY-3+copy_thumbnail.1517598990.jpg',
            },
        ],
        state: 'WY',
        imageUrl: 'images/venues/14826/Snow-King-Hotel-Wedding-Jackson-WY-3+copy_thumbnail.1517598990.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        latitude: 43.215646,
        longitude: -107.555922,
    },
    {
        market: 'Montana',
        regions: [
            {
                name: 'Montana',
                imageUrl: 'images/venues/15279/Sage-Lodge-Pray-MT-e03e6e7e-90a2-486c-9347-d5b3a21fd363_thumbnail.1544557517.png',
            },
        ],
        state: 'MT',
        imageUrl: 'images/venues/15279/Sage-Lodge-Pray-MT-e03e6e7e-90a2-486c-9347-d5b3a21fd363_thumbnail.1544557517.png',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        latitude: 47.127118,
        longitude: -110.090104,
    },
    {
        market: 'New Mexico',
        regions: [
            {
                name: 'New Mexico',
                imageUrl:
                    'images/venues/15127/Taos-Goji-Farm---Eco-Lodge-San-Cristobal-NM-776bd5c6-d493-474c-8fa1-97212bb1b024_thumbnail.1540833143.jpg',
            },
        ],
        state: 'NM',
        imageUrl:
            'images/venues/15127/Taos-Goji-Farm---Eco-Lodge-San-Cristobal-NM-776bd5c6-d493-474c-8fa1-97212bb1b024_thumbnail.1540833143.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        latitude: 34.514213,
        longitude: -105.894853,
    },
    {
        market: 'Colorado',
        regions: [
            {
                name: 'Denver',
                imageUrl: 'images/landing/regions/denver/denver-splash-landscape.jpg',
            },
            {
                name: 'Aspen/Vail/High Rockies',
                imageUrl: 'images/landing/regions/aspen/aspen-splash-landscape.jpg',
            },
            {
                name: 'Colorado Springs',
                imageUrl:
                    'images/venues/16581/Hotel-Elegante-Conference---Event-Center-Colorado-Springs-CO-3ed955d9-a4ed-4198-a256-2035edced1af_thumbnail.1583171395.jpg',
            },
            {
                name: 'Boulder/Fort Collins',
                imageUrl: 'images/landing/regions/boulder_fort_collins/boulder-fort-collins-splash-landscape.jpg',
            },
        ],
        state: 'CO',
        imageUrl: 'images/landing/markets/colorado/colorado-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        latitude: 39.739791,
        longitude: -104.940255,
    },
    {
        market: 'Nebraska',
        regions: [
            {
                name: 'Nebraska',
                imageUrl: 'images/venues/7674/Embassy-Suites-Lincoln-wedding-Lincoln-NE-202075_thumbnail.1515087308.jpg',
            },
        ],
        state: 'NE',
        imageUrl: 'images/venues/7674/Embassy-Suites-Lincoln-wedding-Lincoln-NE-202075_thumbnail.1515087308.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        latitude: 41.660121,
        longitude: -99.820916,
    },
    {
        market: 'South Dakota',
        regions: [
            {
                name: 'South Dakota',
                imageUrl: 'images/venues/7090/Dahl-Arts-Center-Wedding-Rapid-City-SD-1_thumbnail.1450412208.jpg',
            },
        ],
        state: 'SD',
        imageUrl: 'images/venues/7090/Dahl-Arts-Center-Wedding-Rapid-City-SD-1_thumbnail.1450412208.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        latitude: 44.52067,
        longitude: -100.271172,
    },
    {
        market: 'North Dakota',
        regions: [
            {
                name: 'North Dakota',
                imageUrl:
                    'images/venues/13683/Lake-Elsie-Wedding-Barn-Hankinson-ND-24265397-1441-4a41-98a3-256efdd134c8_thumbnail.1578929497.jpg',
            },
        ],
        state: 'ND',
        imageUrl: 'images/venues/13683/Lake-Elsie-Wedding-Barn-Hankinson-ND-24265397-1441-4a41-98a3-256efdd134c8_thumbnail.1578929497.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        latitude: 47.579573,
        longitude: -100.457881,
    },
    {
        market: 'Kansas',
        regions: [
            {
                name: 'Kansas City',
                imageUrl: "images/venues/6996/Life's-Finer-Moments-wedding-Clay-Center-KS-205754_thumbnail.1517935332.png",
            },
            {
                name: 'Wichita',
                imageUrl: 'images/venues/13004/Dyck-Arboretum-of-the-Plains-wedding-Hesston-KS-200858-orig_thumbnail.1514922915.jpg',
            },
        ],
        state: 'KS',
        imageUrl: "images/venues/6996/Life's-Finer-Moments-wedding-Clay-Center-KS-205754_thumbnail.1517935332.png",
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        latitude: 38.546147,
        longitude: -98.234604,
    },
    {
        market: 'Oklahoma',
        regions: [
            {
                name: 'Oklahoma City',
                imageUrl: 'images/venues/13815/Hillside-Manor-Wedding-Norman-OK-7_thumbnail.1504210363.jpg',
            },
            {
                name: 'Tulsa',
                imageUrl:
                    'images/venues/12992/Chapel-on-the-Hill-Broken-Arrow-OK-9f5fc7cf-83e8-4e77-be2d-1f6b8d13fbf9_thumbnail.1578096839.jpg',
            },
            {
                name: 'Stillwater',
                imageUrl:
                    'images/venues/16025/Meditations-Weddings---Events-Stillwater-OK-1013db12-8247-49e0-a21e-f3e0709e81e6_thumbnail.1574007346.jpg',
            },
        ],
        state: 'OK',
        imageUrl:
            'images/venues/16025/Meditations-Weddings---Events-Stillwater-OK-1013db12-8247-49e0-a21e-f3e0709e81e6_thumbnail.1574007346.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 35.544197,
        longitude: -97.475495,
    },
    {
        market: 'Texas',
        regions: [
            {
                name: 'Austin',
                imageUrl: 'images/landing/regions/austin/austin-splash-landscape.jpg',
            },
            {
                name: 'Houston',
                imageUrl: 'images/landing/regions/houston/houston-splash-landscape.jpg',
            },
            {
                name: 'San Antonio',
                imageUrl: 'images/landing/regions/san_antonio/san-antonio-splash-landscape.jpg',
            },
            {
                name: 'Dallas',
                imageUrl: 'images/landing/regions/dallas/dallas-splash-landscape.jpg',
            },
            {
                name: 'Fort Worth',
                imageUrl:
                    'images/venues/5317/Radisson-Hotel-Fossil-Creek-Fort-Worth-TX-7c6127cb-fcfc-4cbc-ba93-58c6b350cdd2_thumbnail.1532038172.png',
            },
            {
                name: 'East Texas',
                imageUrl:
                    'images/venues/9792/Peninsula-Ranch-and-Lodge-Quinlan-TX-41d0d064-c0fd-4187-9858-2e4c63812912_thumbnail.1583261883.jpg',
            },
            {
                name: 'El Paso',
                imageUrl: 'images/venues/2898/The-Gage-Hotel-Wedding-Marathon-TX-+5_thumbnail.1428621464.jpg',
            },
            {
                name: 'Lubbock',
                imageUrl: 'images/venues/5217/American-Wind-Power-Center-Wedding-Lubbock-TX-4_thumbnail.1437165758.jpg',
            },
            {
                name: 'Corpus Christi',
                imageUrl: 'images/venues/9299/The-Pavilions-At-Rockport-Beach-Wedding-San-Anronio-TX5_thumbnail.1479427835.jpg',
            },
            {
                name: 'Hill Country',
                imageUrl: 'images/venues/12282/Ye-Kendall-Inn-Hotel-Wedding-San-Antonio-TX-1_thumbnail.1495065104.jpg',
            },
        ],
        state: 'TX',
        imageUrl: 'images/landing/markets/texas/texas-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 31.520474,
        longitude: -98.859985,
    },
    {
        market: 'Minnesota',
        regions: [
            {
                name: 'Minnesota',
                imageUrl:
                    'images/venues/14254/Radisson-Blu-Minneapolis-Downtown-Minneapolis-MN-a0cca8b9-2538-4d34-8943-3d25d609a1cb_thumbnail.1561403705.jpg',
            },
        ],
        state: 'MN',
        imageUrl:
            'images/venues/14254/Radisson-Blu-Minneapolis-Downtown-Minneapolis-MN-a0cca8b9-2538-4d34-8943-3d25d609a1cb_thumbnail.1561403705.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 46.39862,
        longitude: -94.382518,
    },
    {
        market: 'Iowa',
        regions: [
            {
                name: 'Sioux City',
                imageUrl: 'images/venues/10109/Rustix-Wedding-Humboldt-IA-2_thumbnail.1484871325.jpg',
            },
            {
                name: 'Des Moines',
                imageUrl:
                    'images/venues/16073/Deer-Ridge-at-Lexington-Bedford-IA-f52d29ac-7e35-48e9-9cd0-15a55d266b65_thumbnail.1579206796.jpg',
            },
        ],
        state: 'IA',
        imageUrl: 'images/venues/16073/Deer-Ridge-at-Lexington-Bedford-IA-f52d29ac-7e35-48e9-9cd0-15a55d266b65_thumbnail.1579206796.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 42.196235,
        longitude: -93.305458,
    },
    {
        market: 'Arkansas',
        regions: [
            {
                name: 'Arkansas',
                imageUrl:
                    'images/venues/10562/Mildred-B--Cooper-Memorial-Chapel-Bella-Vista-AR-016c2aff-25df-4c13-bf54-cb70e5b0c243_thumbnail.1571671304.jpg',
            },
        ],
        state: 'AR',
        imageUrl:
            'images/venues/10562/Mildred-B--Cooper-Memorial-Chapel-Bella-Vista-AR-016c2aff-25df-4c13-bf54-cb70e5b0c243_thumbnail.1571671304.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 34.839679,
        longitude: -92.269129,
    },
    {
        market: 'Missouri',
        regions: [
            {
                name: 'St. Louis',
                imageUrl: 'images/markets/Missouri/St.+Louis/Bevo-Mill-St.-Louis-MO-2_thumbnail.1414099205.jpg',
            },
            {
                name: 'Southeast Missouri',
                imageUrl: 'images/venues/14458/Bear-River-Ranch-Wedding-Rolla-MO-1_thumbnail.1511802649.jpg',
            },
            {
                name: 'Springfield',
                imageUrl:
                    'images/venues/14088/Lil--Boom-Town-Wedding-Venue---Event-Center--LLC-Aurora-MO-2607f97e-22ba-41b7-b07f-342cc896eb8c_thumbnail.1539014148.jpg',
            },
            {
                name: 'Kansas City',
                imageUrl: "images/venues/6996/Life's-Finer-Moments-wedding-Clay-Center-KS-205754_thumbnail.1517935332.png",
            },
        ],
        state: 'MO',
        imageUrl: 'images/landing/markets/missouri/missouri-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 38.628365,
        longitude: -90.197923,
    },
    {
        market: 'Wisconsin',
        regions: [
            {
                name: 'Milwaukee',
                imageUrl: 'images/venues/16575/Red-Circle-Inn-Nashotah-WI-bb4ade28-d8be-4415-9264-8217c3fe8191_thumbnail.1582643161.jpg',
            },
            {
                name: 'Madison',
                imageUrl:
                    'images/venues/13039/The-Fort-Atkinson-Club-Community-Center-Fort-Atkinson-WI-66267eed-e602-453c-9dcd-594d21f7d81d_thumbnail.1585163918.jpg',
            },
            {
                name: 'Green Bay',
                imageUrl:
                    'images/venues/16432/Artesia-Schoolhouse-Malone--Chilton--WI-21ec94df-e1d4-4c28-9b40-6230ae7c4b2e_thumbnail.1573865565.jpg',
            },
            {
                name: 'Eau Claire',
                imageUrl: 'images/venues/16517/Paradise-Shores-4-Holcombe-WI-7db7ad16-8c80-43a1-a03b-a41d722e3c36_thumbnail.1584385905.jpg',
            },
            {
                name: 'Wausau',
                imageUrl: 'images/venues/14924/800x800_1504633769787-patiomusic_thumbnail.1520616991.jpg',
            },
        ],
        state: 'WI',
        imageUrl: 'images/venues/16575/Red-Circle-Inn-Nashotah-WI-bb4ade28-d8be-4415-9264-8217c3fe8191_thumbnail.1582643161.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 44.684841,
        longitude: -89.672896,
    },
    {
        market: 'Illinois',
        regions: [
            {
                name: 'Chicago',
                imageUrl: 'images/landing/regions/chicago/chicago-splash-landscape.jpg',
            },
            {
                name: 'Central Illinois',
                imageUrl:
                    'images/venues/14359/Peoria-Marriott-Pere-Marquette-Peoria-IL-40b91d73-ab03-4a1f-a353-eef9441aac70_thumbnail.1576076028.png',
            },
            {
                name: 'Southern Illinois',
                imageUrl:
                    'images/venues/6460/Beall-Mansion-An-Elegant-Bed---Breakfast-Inn-Alton-IL-b2f61aa5-2733-4612-9142-c9d654b7b558_thumbnail.1536069853.png',
            },
        ],
        state: 'IL',
        imageUrl: 'images/landing/markets/illinois/illinois-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 40.311389,
        longitude: -89.152577,
    },
    {
        market: 'Louisiana',
        regions: [
            {
                name: 'New Orleans',
                imageUrl:
                    'images/venues/15890/Southern-Oaks-Plantation-New-Orleans-LA-abd19404-bfb7-4a5d-8b05-f55029a2eb27_thumbnail.1557853906.jpg',
            },
            {
                name: 'Baton Rouge',
                imageUrl:
                    'images/venues/15978/Louisiana-Cajun-Mansion-Bed-and-Breakfast-United-States-b9b1f336-0454-4817-976b-77d56a8413a0_thumbnail.1564700405.jpg',
            },
            {
                name: 'Shreveport',
                imageUrl: 'images/venues/8858/Bossier-Civic-Center-Shreveport-LA-1_thumbnail.1476122894.jpg',
            },
            {
                name: 'Northern Louisiana',
                imageUrl: 'images/venues/13448/The-Melady-House-Wedding-Alexandria-LA-3_thumbnail.1502209708.jpg',
            },
            {
                name: 'Acadiana',
                imageUrl:
                    'images/venues/16622/Dream-Castle-Event-Venue-Broussard-LA-87f10148-7400-4d71-b7fc-89508813cbac_thumbnail.1589384374.jpg',
            },
        ],
        state: 'LA',
        imageUrl:
            'images/venues/15890/Southern-Oaks-Plantation-New-Orleans-LA-abd19404-bfb7-4a5d-8b05-f55029a2eb27_thumbnail.1557853906.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 31.195944,
        longitude: -91.972272,
    },
    {
        market: 'Mississippi',
        regions: [
            {
                name: 'Mississippi',
                imageUrl: 'images/venues/13522/Biloxi-Yacht-Club-Wedding-Biloxi-MS-5_thumbnail.1502729448.jpg',
            },
        ],
        state: 'MS',
        imageUrl: 'images/venues/13522/Biloxi-Yacht-Club-Wedding-Biloxi-MS-5_thumbnail.1502729448.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 32.897978,
        longitude: -89.651335,
    },
    {
        market: 'Indiana',
        regions: [
            {
                name: 'Southern Indiana',
                imageUrl: 'images/venues/12835/The-Destination-Salem-IN-87e4211c-0bdd-4718-b854-2962baa0e6fb_thumbnail.1543853486.jpg',
            },
            {
                name: 'Indianapolis/Central Indiana',
                imageUrl:
                    'images/venues/10601/Hyatt-Regency-Indianapolis-Indianapolis-IN-9f4d9274-ebe1-4ed1-905c-e8e8221837ea_thumbnail.1576525716.jpg',
            },
            {
                name: 'Northeast Indiana',
                imageUrl:
                    'images/venues/8475/Crystal-Ballroom-at-the-Lerner-Elkhart-IN-13b734cd-6739-4093-922b-2d211b276dc7_thumbnail.1568811226.jpg',
            },
            {
                name: 'Northwest Indiana',
                imageUrl:
                    'images/venues/11510/South-Bend-Country-Club-South-Bend-IN-597c0382-ec2d-49af-8e72-6939c8fe07a8_thumbnail.1568810112.jpg',
            },
        ],
        state: 'IN',
        imageUrl:
            'images/venues/8475/Crystal-Ballroom-at-the-Lerner-Elkhart-IN-13b734cd-6739-4093-922b-2d211b276dc7_thumbnail.1568811226.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 39.84218,
        longitude: -86.161126,
    },
    {
        market: 'Tennessee',
        regions: [
            {
                name: 'Nashville',
                imageUrl:
                    'images/venues/6695/Union-Station-Hotel-Nashville-TN-be468c5c-98e3-4f0f-892a-710d10a1c29a_thumbnail.1550254779.jpg',
            },
            {
                name: 'Memphis',
                imageUrl: 'images/venues/8984/Colonial-Country-Club-Wedding-Memphis-TN-1_thumbnail.1477112146.jpg',
            },
            {
                name: 'Chattanooga',
                imageUrl: 'images/venues/13303/The-Read-House-Chattanooga-TN-f0d15226-cf6b-403b-b818-ab8fc44e1a77_thumbnail.1578589404.jpg',
            },
            {
                name: 'Knoxville',
                imageUrl:
                    'images/venues/7778/Tellico-Village-Yacht-Club-Loudon-TN-5944aef4-a00e-4b6f-b641-f61dd9822bf1_thumbnail.1573578785.jpg',
            },
            {
                name: 'Gatlinburg',
                imageUrl: 'images/venues/13578/The-Magnolia-Pigeon-Forge-TN-c6843ec0-36d2-4bc3-9b6f-833a241addd0_thumbnail.1581432909.jpg',
            },
        ],
        state: 'TN',
        imageUrl: 'images/venues/13578/The-Magnolia-Pigeon-Forge-TN-c6843ec0-36d2-4bc3-9b6f-833a241addd0_thumbnail.1581432909.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 35.857238,
        longitude: -86.407066,
    },
    {
        market: 'Alaska',
        regions: [
            {
                name: 'Alaska',
                imageUrl:
                    'images/venues/15996/The-Gathering-Place-Wasilla-AK-77eb4ae1-fd92-4583-a26a-5a9d56b476c2_thumbnail.1567281946.jpg',
            },
        ],
        state: 'AK',
        imageUrl: 'images/venues/15996/The-Gathering-Place-Wasilla-AK-77eb4ae1-fd92-4583-a26a-5a9d56b476c2_thumbnail.1567281946.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 61.216642,
        longitude: -149.899802,
    },
    {
        market: 'Kentucky',
        regions: [
            {
                name: 'Louisville',
                imageUrl: 'images/venues/6697/Red-Orchard-Barn-Wedding-Shelbyville-KY-11_thumbnail.1447892723.jpg',
            },
            {
                name: 'Lexington',
                imageUrl:
                    'images/venues/16564/The-Madison-Event-Center-COVINGTON-KY-8a909bf4-612a-42d7-9cee-455217a9e92d_thumbnail.1582237365.jpg',
            },
            {
                name: 'Bowling Green',
                imageUrl: "images/venues/10962/Mariah's-Wedding-Bowling-Green-KY-10_thumbnail.1490020013.jpg",
            },
        ],
        state: 'KY',
        imageUrl: 'images/venues/16564/The-Madison-Event-Center-COVINGTON-KY-8a909bf4-612a-42d7-9cee-455217a9e92d_thumbnail.1582237365.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 37.439462,
        longitude: -85.394705,
    },
    {
        market: 'Alabama',
        regions: [
            {
                name: 'Birmingham',
                imageUrl: 'images/venues/15503/The-Sterling-Castle-Shelby-AL-434c9546-53b9-4ce1-9dd6-b5cd3efe1661_thumbnail.1548910594.jpg',
            },
            {
                name: 'Huntsville',
                imageUrl:
                    'images/venues/16558/Burns-Bluff-at-High-Falls-Albertville-AL-548269c4-281f-484c-a299-e337b5a85415_thumbnail.1582171570.jpg',
            },
            {
                name: 'Southern Alabama',
                imageUrl: 'images/venues/7324/The-Beach-Club-Gulf-Shores-AL-4028a05d-5d86-4d98-8d3c-39db16901bc7_thumbnail.1582558296.jpg',
            },
        ],
        state: 'AL',
        imageUrl:
            'images/venues/16558/Burns-Bluff-at-High-Falls-Albertville-AL-548269c4-281f-484c-a299-e337b5a85415_thumbnail.1582171570.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 33.035235,
        longitude: -86.692319,
    },
    {
        market: 'Michigan',
        regions: [
            {
                name: 'Detroit',
                imageUrl: 'images/landing/regions/detroit/detroit-splash-landscape.jpg',
            },
            {
                name: 'Ann Arbor',
                imageUrl:
                    'images/venues/4609/Michigan-Union---University-of-Michigan-Ann-Arbor-MI-ecd7fae4-c4f6-4626-8d12-d9ba4b52a3f6_thumbnail.1579878117.jpg',
            },
            {
                name: 'Grand Rapids',
                imageUrl: 'images/venues/15470/Bay-Pointe-Shelbyville-MI-449d6d26-6f51-4598-a3e3-3e29fb1b8442_thumbnail.1581620104.jpg',
            },
            {
                name: 'Kalamazoo',
                imageUrl: 'images/venues/15470/Bay-Pointe-Shelbyville-MI-449d6d26-6f51-4598-a3e3-3e29fb1b8442_thumbnail.1581620104.jpg',
            },
            {
                name: 'Traverse City',
                imageUrl: 'images/venues/8147/Castle-Farms-Charlevoix-MI-2c64224c-4af3-4b32-8f4e-7c2e154406ce_thumbnail.1577736034.jpg',
            },
            {
                name: 'Lansing',
                imageUrl:
                    'images/venues/15307/FireKeepers-Casino-United-States-79ea9369-77e7-42c4-8ea7-87c81571760b_thumbnail.1546890459.jpg',
            },
            {
                name: 'Mackinac Island',
                imageUrl: 'images/venues/9581/Grand-Hotel-Mackinac-Island-Wedding-Mackinac-Island-MI-1_thumbnail.1482221317.jpg',
            },
        ],
        state: 'MI',
        imageUrl: 'images/landing/markets/michigan/michigan-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 42.336011,
        longitude: -83.050136,
    },
    {
        market: 'Ohio',
        regions: [
            {
                name: 'Cincinnati',
                imageUrl: 'images/landing/regions/cincinnati/cincinnati-splash-landscape.jpg',
            },
            {
                name: 'Cleveland',
                imageUrl: 'images/landing/regions/cleveland/cleveland-splash-landscape.jpg',
            },
            {
                name: 'Columbus',
                imageUrl: 'images/landing/regions/columbus/columbus-splash-landscape.jpg',
            },
            {
                name: 'Toledo',
                imageUrl: 'images/venues/16082/Hancock-Hotel-Findlay-OH-52f3e47a-160f-4cfa-a0d9-205d7e55e8df_thumbnail.1569271858.jpg',
            },
            {
                name: 'Dayton',
                imageUrl:
                    'images/venues/5839/Walnut-Grove-Country-Club-Dayton-OH-661c0a02-20e5-4bed-8b01-bfd6d90e27e0_thumbnail.1540396084.jpg',
            },
            {
                name: 'Southeast Ohio',
                imageUrl:
                    'images/venues/16530/Kalahari-Resorts---Conventions-Sandusky-Sandusky-OH-469e6cd0-5ea6-4450-ad9b-97437513f800_thumbnail.1581525686.jpg',
            },
        ],
        state: 'OH',
        imageUrl: 'images/landing/markets/ohio/ohio-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 39.966376,
        longitude: -82.999755,
    },
    {
        market: 'Georgia',
        regions: [
            {
                name: 'Atlanta',
                imageUrl: 'images/landing/regions/atlanta/atlanta-splash-landscape.jpg',
            },
            {
                name: 'Savannah',
                imageUrl:
                    'images/venues/8660/Musgrove-Retreat-Saint-Simons-Island-GA-4961d3d9-7edb-400e-958d-cc0207b255a1_thumbnail.1574192925.png',
            },
            {
                name: 'Macon',
                imageUrl: 'images/venues/10878/Ramada-Inn-and-Conference-Center-Warner-Robins-Wedding-Macon-GA-1_thumbnail.1489023220.jpg',
            },
            {
                name: 'Columbus',
                imageUrl: 'images/venues/3996/Cherry-Valley-Lodge-WEdding-Newark-OH-1_thumbnail.1432943626.jpg',
            },
        ],
        state: 'GA',
        imageUrl: 'images/landing/markets/georgia/georgia-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 33.010409,
        longitude: -83.431716,
    },
    {
        market: 'West Virginia',
        regions: [
            {
                name: 'West Virginia',
                imageUrl:
                    'images/venues/16024/Crooked-Creek-Run-High-View-WV-9593d8ff-8714-4374-bc79-dda423a3997b_thumbnail.1570032145.jpg',
            },
        ],
        state: 'WV',
        imageUrl: 'images/venues/16024/Crooked-Creek-Run-High-View-WV-9593d8ff-8714-4374-bc79-dda423a3997b_thumbnail.1570032145.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 37.531685,
        longitude: -80.663048,
    },
    {
        market: 'South Carolina',
        regions: [
            {
                name: 'Charleston',
                imageUrl: 'images/venues/6594/Magnolia-Plantation-&-Gardens-Wedding-Charleston-IN-6_thumbnail.1446803912.jpg',
            },
            {
                name: 'Myrtle Beach',
                imageUrl: 'images/venues/6562/Holiday-Inn-Oceanfront-Wedding-Surfside-Beach-SC-1_thumbnail.1446550296.jpg',
            },
            {
                name: 'Columbia',
                imageUrl: 'images/venues/10613/Lace-House-Wedding-Columbia-SC-3_thumbnail.1487797228.jpg',
            },
            {
                name: 'Hilton Head',
                imageUrl:
                    'images/venues/7903/Palmetto-Dunes-Oceanfront-Resort-Hilton-Head-Island-SC-e0d885b3-07cb-4ac3-9fad-11014c31bf0d_thumbnail.1566413811.jpg',
            },
            {
                name: 'Greenville',
                imageUrl:
                    'images/venues/16514/The-Westin-Poinsett-Greenville-Greenville-SC-2a39d06b-0b97-41ef-adad-2085b7cf2e79_thumbnail.1577478148.jpg',
            },
        ],
        state: 'SC',
        imageUrl:
            'images/venues/7903/Palmetto-Dunes-Oceanfront-Resort-Hilton-Head-Island-SC-e0d885b3-07cb-4ac3-9fad-11014c31bf0d_thumbnail.1566413811.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 33.976577,
        longitude: -80.783116,
    },
    {
        market: 'Florida',
        regions: [
            {
                name: 'Miami',
                imageUrl: 'images/landing/regions/miami/miami-splash-landscape.jpg',
            },
            {
                name: 'Orlando',
                imageUrl: 'images/landing/regions/orlando/orlando-splash-landscape.jpg',
            },
            {
                name: 'Tampa',
                imageUrl: 'images/landing/regions/tampa/tampa-splash-landscape.jpg',
            },
            {
                name: 'Northwest Florida',
                imageUrl: 'images/landing/regions/northwest_florida/northwest-florida-splash-landscape.jpg',
            },
            {
                name: 'Florida Keys',
                imageUrl:
                    'images/venues/9550/Key-Largo-Lighthouse-Key-West-FL-539a4b5e-47fe-4a31-be98-16378689a6aa_thumbnail.1573652734.jpg',
            },
            {
                name: 'Fort Lauderdale',
                imageUrl: 'images/venues/5257/B-Ocean-Resort-Fort-Lauderdale-Wedding-Fort-Lauderdale-FL-2_thumbnail.1437422081.png',
            },
            {
                name: 'Central Florida Beaches/Coast',
                imageUrl: 'images/venues/11926/Night-Swan-Intracoastal-Bed-and-Breakfast-Wedding-Orlando-FL-6_thumbnail.1493334420.jpg',
            },
            {
                name: 'Boca Raton',
                imageUrl:
                    'images/venues/16406/PGA-National-Resort---Spa-Palm-Beach-Gardens-FL-0c5e51e9-efa3-4e07-8b33-bd2850d16cb0_thumbnail.1573078732.jpg',
            },
            {
                name: 'Naples/Fort Myers',
                imageUrl: 'images/venues/14354/Hyatt-Regency-Coconut-Point-Resort-&-Spa-Bonita-Springs-FL-11_thumbnail.1512604832.jpg',
            },
            {
                name: 'Jacksonville',
                imageUrl:
                    'images/venues/9525/Treasury-on-the-Plaza-St-Augustine-FL-62bddcda-7c4d-450f-99f8-1d897f7807f8_thumbnail.1538693200.jpg',
            },
        ],
        state: 'FL',
        imageUrl: 'images/landing/markets/florida/florida-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 29.251052,
        longitude: -82.903465,
    },
    {
        market: 'Virginia',
        regions: [
            {
                name: 'Richmond',
                imageUrl: 'images/landing/regions/richmond/richmond-splash-landscape.jpg',
            },
            {
                name: 'Charlottesville',
                imageUrl: 'images/landing/regions/charlottesville/charlottesville-splash-landscape.jpg',
            },
            {
                name: 'Virginia Beach',
                imageUrl:
                    'images/venues/15087/Sandbridge-Reality-Virginia-Beach-VA-aecdb23d-5822-480e-a44e-45c8ee96e78b_thumbnail.1529515254.jpg',
            },
            {
                name: 'Lexington',
                imageUrl:
                    'images/venues/16564/The-Madison-Event-Center-COVINGTON-KY-8a909bf4-612a-42d7-9cee-455217a9e92d_thumbnail.1582237365.jpg',
            },
            {
                name: 'Fredericksburg',
                imageUrl:
                    'images/venues/10641/Prince-William-County-Historic-Preservation-Division-Dumfries-VA-2748f373-9eaa-4001-8205-25c99af8b853_thumbnail.1537882032.jpg',
            },
            {
                name: 'Northern Virginia',
                imageUrl: 'images/landing/regions/arlington/arlington-splash-landscape.jpg',
            },
            {
                name: 'Southwest Virginia',
                imageUrl: 'images/venues/3316/Sundara-Wedding-Dells-WI-5_thumbnail.1430510521.jpg',
            },
        ],
        state: 'VA',
        imageUrl: 'images/landing/markets/virginia/virginia-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 37.600838,
        longitude: -78.480626,
    },
    {
        market: 'North Carolina',
        regions: [
            {
                name: 'Raleigh/Triangle',
                imageUrl: 'images/landing/regions/raleigh/raleigh-splash-landscape.jpg',
            },
            {
                name: 'Charlotte',
                imageUrl: 'images/landing/regions/charlotte/charlotte-splash-landscape.jpg',
            },
            {
                name: 'Greensboro/Triad',
                imageUrl: 'images/venues/4703/Rosa-Lee-Manor-wedding-Pilot-Mountain-NC-167592-orig_thumbnail.1492802391.jpg',
            },
            {
                name: 'Wilmington',
                imageUrl:
                    'images/venues/3374/The-Village-at-River-Landing-Wallace-NC-5be87310-531d-4c82-9f77-2e4d38291468_thumbnail.1548275003.jpg',
            },
            {
                name: 'Outer Banks',
                imageUrl:
                    'images/venues/13291/Butterfly-Kisses-Pavilion-Newport-NC-245962c5-92f1-42d1-a9ee-7d550b0ca9c1_thumbnail.1550176270.jpg',
            },
            {
                name: 'Winston-Salem',
                imageUrl: null,
            },
            {
                name: 'Asheville',
                imageUrl:
                    'images/venues/14646/Rumbling-Bald-Resort-Lake-Lure-NC-a543a355-e7f8-4f90-816f-9514f68b5bd1_thumbnail.1572459284.jpg',
            },
            {
                name: 'Winston-Salem/Mountains',
                imageUrl:
                    'images/venues/12842/Roaring-River-Vineyards-Traphill-NC-ca93ea58-11a5-4bd1-a71a-0148c19f3b18_thumbnail.1524060349.jpg',
            },
        ],
        state: 'NC',
        imageUrl: 'images/landing/markets/north_carolina/north-carolina-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 35.653184,
        longitude: -79.056307,
    },
    {
        market: 'Hawaii',
        regions: [
            {
                name: 'Oahu',
                imageUrl: 'images/landing/regions/oahu/oahu-splash-landscape.jpg',
            },
            {
                name: 'Maui',
                imageUrl: 'images/landing/regions/maui/maui-splash-landscape.jpg',
            },
            {
                name: 'Hawaii (Big Island)',
                imageUrl: 'images/landing/regions/hawaii_big_island/hawaii-big-island-splash-landscape.jpg',
            },
            {
                name: 'Kauai',
                imageUrl: 'images/landing/regions/kauai/kauai-splash-landscape.jpg',
            },
            {
                name: 'Honolulu',
                imageUrl:
                    'images/venues/445/Hyatt-Regency-Waikiki-Beach-Resort---Spa-Honolulu-HI-fa237a64-6cd5-464f-b4a3-5c7a3506d43e_thumbnail.1586223745.jpg',
            },
        ],
        state: 'HI',
        imageUrl: 'images/landing/markets/hawaii/hawaii-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 20.4,
        longitude: -157.6333,
    },
    {
        market: 'District of Columbia',
        regions: [
            {
                name: 'Washington DC',
                imageUrl: 'images/venues/16601/Schuyler-Washington-DC-d5350d56-efc7-43e0-b15b-124a03ead7f7_thumbnail.1584732886.jpg',
            },
        ],
        state: 'DC',
        imageUrl: 'images/landing/markets/dc/dc-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 38.907724,
        longitude: -77.036549,
    },
    {
        market: 'Maryland',
        regions: [
            {
                name: 'Baltimore',
                imageUrl: 'images/landing/regions/baltimore/baltimore-splash-landscape.jpg',
            },
            {
                name: 'Annapolis',
                imageUrl: 'images/landing/regions/annapolis/annapolis-splash-landscape.jpg',
            },
            {
                name: 'Eastern Shore/Chesapeake Bay',
                imageUrl: 'images/landing/regions/eastern_shore/eastern-shore-splash-landscape.jpg',
            },
            {
                name: 'Frederick',
                imageUrl:
                    'images/venues/13073/Richland-Golf-Club-Middletown-MD-63373b0b-0f6d-43a6-9f08-9584fe59e31a_thumbnail.1542417784.jpg',
            },
        ],
        state: 'MD',
        imageUrl: 'images/landing/markets/maryland/maryland-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 39.290287,
        longitude: -76.61259,
    },
    {
        market: 'Pennsylvania',
        regions: [
            {
                name: 'Philadelphia',
                imageUrl: 'images/landing/regions/philadelphia/philadelphia-splash-landscape.jpg',
            },
            {
                name: 'Pittsburgh',
                imageUrl: 'images/landing/regions/pittsburgh/pittsburgh-splash-landscape.jpg',
            },
            {
                name: 'Lehigh Valley/Poconos',
                imageUrl: "images/venues/5812/Carmen's-Country-Inn-and-Gardens-Wedding-Drums-PA-7_thumbnail.1440578847.jpg",
            },
            {
                name: 'Central PA',
                imageUrl: 'images/venues/14925/Riverdale-Manor-Lancaster-PA-8ced88fc-9a08-4a8d-85ea-73b3a83fe0f5_thumbnail.1571418869.jpg',
            },
            {
                name: 'Northwest PA',
                imageUrl:
                    'images/venues/16529/Kalahari-Resorts---Conventions-Poconos-Pocono-Manor-PA-6a18ba42-5dd7-498f-9a23-aba250962063_thumbnail.1581525446.jpg',
            },
            {
                name: 'South Central PA',
                imageUrl:
                    'images/venues/12792/Historic-Acres-of-Hershey-Elizabethtown-PA-d58856f3-cb33-4f21-8339-772b4382e9d7_thumbnail.1571416019.jpg',
            },
        ],
        state: 'PA',
        imageUrl: 'images/landing/markets/pennsylvania/pennsylvania-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 40.606502,
        longitude: -75.492403,
    },
    {
        market: 'Delaware',
        regions: [
            {
                name: 'Delaware',
                imageUrl:
                    'images/venues/16592/The-Bellmoor-Inn-and-Spa-Rehoboth-Beach-DE-4caa4639-0f11-42da-93be-adeeec4d3359_thumbnail.1585236349.jpg',
            },
        ],
        state: 'DE',
        imageUrl:
            'images/venues/16592/The-Bellmoor-Inn-and-Spa-Rehoboth-Beach-DE-4caa4639-0f11-42da-93be-adeeec4d3359_thumbnail.1585236349.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 38.904138,
        longitude: -75.421667,
    },
    {
        market: 'New Jersey',
        regions: [
            {
                name: 'North Jersey',
                imageUrl: 'images/landing/regions/north_jersey/north-jersey-splash-landscape.jpg',
            },
            {
                name: 'Atlantic City',
                imageUrl: 'images/landing/regions/atlantic_city/atlantic-city-splash-landscape.jpg',
            },
            {
                name: 'Jersey Shore',
                imageUrl: 'images/landing/regions/jersey_shore/jersey-shore-splash-landscape.jpg',
            },
            {
                name: 'South Jersey',
                imageUrl: 'images/venues/16552/The-Merion-Cinnaminson-NJ-d9272868-a7b0-4b82-93c4-4e3f2a5ec978_thumbnail.1581022790.jpg',
            },
            {
                name: 'Central Jersey',
                imageUrl:
                    'images/venues/14459/Princeton-Meadow-Event-Center-Princeton-NJ-bd1fe49e-39e9-4346-bc70-3fc75656e497_thumbnail.1543870454.jpg',
            },
        ],
        state: 'NJ',
        imageUrl: 'images/landing/markets/new_jersey/new-jersey-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 40.113623,
        longitude: -74.341101,
    },
    {
        market: 'New York',
        regions: [
            {
                name: 'Long Island',
                imageUrl: 'images/landing/regions/long_island/long-island-splash-landscape.jpg',
            },
            {
                name: 'Manhattan',
                imageUrl: 'images/landing/regions/manhattan/manhattan-splash-landscape.jpg',
            },
            {
                name: 'Brooklyn',
                imageUrl: 'images/landing/regions/brooklyn/brooklyn-splash-landscape.jpg',
            },
            {
                name: 'Staten Island',
                imageUrl: 'images/venues/1318/Grand-Oaks-Staten-Island-NY-81a838a2-11cd-472f-9c2c-1bfd33231c36_thumbnail.1581310210.jpg',
            },
            {
                name: 'Queens',
                imageUrl: 'images/venues/1887/Antuns-of-Queens-Village-Wedding-Queens-Village-NY-42_thumbnail.1490311035.jpg',
            },
            {
                name: 'The Bronx',
                imageUrl: 'images/venues/8635/The-New-York-Botanical-Garden-wedding-Bronx-NY-154653-orig_thumbnail.1487357126.jpg',
            },
            {
                name: 'Hamptons',
                imageUrl:
                    'images/venues/469/Gurney-s-Montauk-Resort-and-Seawater-Spa-Montauk-NY-9e3531d1-c60c-47e0-a9f9-3800f02137ac_thumbnail.1554151776.jpg',
            },
            {
                name: 'Westchester/Hudson Valley',
                imageUrl:
                    'images/venues/2340/FEAST-at-Round-Hill-Washingtonville-NY-f8e38fb7-b36b-460c-9393-8d029de647d9_thumbnail.1568301447.jpg',
            },
            {
                name: 'Eastern Adirondacks/Lake Champlain',
                imageUrl:
                    'images/venues/1823/The-Chateau-on-the-Lake--Bolton-Landing-Bolton-Landing-NY-625457e8-415d-49a0-bf93-8dce22765df9_thumbnail.1560812775.jpg',
            },
            {
                name: 'Western Adirondacks/Eastern Lake Ontario',
                imageUrl: 'images/venues/9250/Utica-Zoo-Wedding-New-York-NY-4_thumbnail.1480362994.jpg',
            },
            {
                name: 'Finger Lakes',
                imageUrl: 'images/venues/1334/Turning-Stone-Resort-Casino-Verona-NY-2_thumbnail.1417028760.jpg',
            },
            {
                name: 'Western New York',
                imageUrl: "images/venues/13795/The-Atrium-at-Rich's-Wedding-Buffalo-NY1_thumbnail.1504128286.jpg",
            },
        ],
        state: 'NY',
        imageUrl: 'images/landing/markets/new_york/new-york-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 40.74985,
        longitude: -73.995525,
    },
    {
        market: 'Vermont',
        regions: [
            {
                name: 'Vermont',
                imageUrl: 'images/markets/Vermont/Vermont/Hewitt+Wedding+Woodstock+VT+6_thumbnail.jpg',
            },
        ],
        state: 'VT',
        imageUrl: 'images/landing/markets/vermont/vermont-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 43.622136,
        longitude: -72.518545,
    },
    {
        market: 'Connecticut',
        regions: [
            {
                name: 'Litchfield',
                imageUrl:
                    'images/venues/5228/Tarrywile-Park---Mansion-Danbury-CT-7963a62a-eda2-4bad-b866-1296e7b38f06_thumbnail.1577719539.jpg',
            },
            {
                name: 'Hartford',
                imageUrl:
                    'images/venues/5237/The-Mansion-at-Bald-Hill-Woodstock-CT-b3362eb3-408e-4bdd-9f5e-23bec5215309_thumbnail.1582310718.jpg',
            },
            {
                name: 'New London',
                imageUrl: 'images/venues/9157/Salt-Water-Farm-Vineyard-Wedding-Connecticut-CT-1_thumbnail.1478607553.jpg',
            },
            {
                name: 'New Haven',
                imageUrl: 'images/venues/10174/Il-Palio-Shelton-CT-ed88b78d-059d-45f2-8aab-d85fc5bab22e_thumbnail.1535562099.jpg',
            },
            {
                name: 'Greater Bridgeport',
                imageUrl:
                    'images/venues/5229/Hyatt-Regency-Greenwich-Old-Greenwich-CT-c9d76112-8e74-4f5a-90bd-29fcc1f52e75_thumbnail.1581099343.jpg',
            },
        ],
        state: 'CT',
        imageUrl: 'images/venues/10174/Il-Palio-Shelton-CT-ed88b78d-059d-45f2-8aab-d85fc5bab22e_thumbnail.1535562099.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 41.650264,
        longitude: -72.691589,
    },
    {
        market: 'New Hampshire',
        regions: [
            {
                name: 'New Hampshire',
                imageUrl: 'images/venues/13145/Brookstone-Park-Derry-NH-2969d584-4c43-4f1c-bc10-9497b649c3ed_thumbnail.1571095327.png',
            },
            {
                name: 'Great North Woods/White Mountains',
                imageUrl:
                    'images/venues/3045/The-Gables-at-Chadds-Ford-Chadds-Ford-PA-abf47390-919b-49d7-97a2-04366b2e7e47_thumbnail.1571440105.jpg',
            },
            {
                name: 'Dartmouth/Monadnock',
                imageUrl: 'images/venues/6759/The-Woodbound-Inn-Rindge-NH-137e0290-b0ad-49b2-80c6-11e7157d27b1_thumbnail.1544721707.jpg',
            },
            {
                name: 'Merrimack',
                imageUrl: 'images/venues/6143/The-Margate-Resort-Wedding-Laconia-NH-1_thumbnail.1443067718.jpg',
            },
        ],
        state: 'NH',
        imageUrl: 'images/venues/6143/The-Margate-Resort-Wedding-Laconia-NH-1_thumbnail.1443067718.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 43.672361,
        longitude: -71.426115,
    },
    {
        market: 'Rhode Island',
        regions: [
            {
                name: 'Providence/Northern Rhode Island',
                imageUrl: 'images/venues/6435/Hope-Events-on-Main-Wedding-Tucket-RI-2_thumbnail.1445848588.jpg',
            },
            {
                name: 'Coastal Rhode Island',
                imageUrl:
                    'images/venues/15156/The-Atlantic-Resort-Newport-Middletown-RI-e94ad838-9ee2-4875-a214-a340711cc3b7_thumbnail.1535416163.jpg',
            },
        ],
        state: 'RI',
        imageUrl:
            'images/venues/15156/The-Atlantic-Resort-Newport-Middletown-RI-e94ad838-9ee2-4875-a214-a340711cc3b7_thumbnail.1535416163.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 41.689894,
        longitude: -71.489878,
    },
    {
        market: 'Massachusetts',
        regions: [
            {
                name: 'Boston',
                imageUrl: 'images/markets/Massachusetts/Boston/Brookmeadow-Country-Club-Canton-MA-1_thumbnail.1414543832.jpg',
            },
            {
                name: 'North Shore',
                imageUrl:
                    'images/venues/6655/DoubleTree-by-Hilton-Boston-North-Shore-wedding-Danvers-MA-178890-orig_thumbnail.1498588464.jpg',
            },
            {
                name: 'Central Massachusetts',
                imageUrl: 'images/venues/16423/Beechwood-Hotel-Worcester-MA-742b39e8-17f0-4796-b7d9-e30819cd6c9a_thumbnail.1573243685.jpg',
            },
            {
                name: 'South Shore',
                imageUrl:
                    'images/venues/15523/Raffael-s-at-South-Shore-Country-Club-Hingham-MA-14077da9-13f2-4de8-b2c6-ee1a5ea3c253_thumbnail.1550704422.jpg',
            },
            {
                name: 'Western Massachusetts',
                imageUrl:
                    'images/venues/16090/The-Red-Lion-Inn-and-Barn-Cohasset-MA-2255ca89-5697-48e2-974e-743d0b4906c7_thumbnail.1582148597.jpg',
            },
            {
                name: 'Cape Cod and Islands',
                imageUrl: 'images/markets/Massachusetts/Cape+Cod/White-Cliffs-Country-Club-Wedding-Sharon-MA-1_thumbnail.1404069278.jpg',
            },
        ],
        state: 'MA',
        imageUrl: 'images/landing/markets/massachusetts/massachusetts-splash-landscape.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 42.356581,
        longitude: -71.061792,
    },
    {
        market: 'Maine',
        regions: [
            {
                name: 'Maine',
                imageUrl:
                    'images/venues/16599/Kennebunkport-Resort--Hidden-Pond-Kennebunkport-ME-38529759-82af-4d9a-8d34-9db93103d213_thumbnail.1584735726.jpg',
            },
        ],
        state: 'ME',
        imageUrl:
            'images/venues/16599/Kennebunkport-Resort--Hidden-Pond-Kennebunkport-ME-38529759-82af-4d9a-8d34-9db93103d213_thumbnail.1584735726.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 45.399677,
        longitude: -69.241828,
    },
    {
        market: 'Mexico',
        regions: [
            {
                name: 'Mexico',
                imageUrl:
                    'images/venues/16078/Marquis-Los-Cabos-San-Jos--del-Cabo-Mexico-4ffdea81-c7c1-4335-a806-3332cfa63c7d_thumbnail.1570824006.jpg',
            },
        ],
        state: 'MX',
        imageUrl: 'images/venues/16078/Marquis-Los-Cabos-San-Jos--del-Cabo-Mexico-4ffdea81-c7c1-4335-a806-3332cfa63c7d_thumbnail.1570824006.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        //fetched the lat and long from https://www.latlong.net/place/mexico-city-mexico-2363.html
        latitude: 19.432608,
        longitude: -99.133209,
    },
    {
        market: 'Costa Rica',
        regions: [
            {
                name: 'Costa Rica',
                imageUrl:
                    'images/venues/15339/Riu-Palace-Costa-Rica-Sardinal-de-Carrillo-Costa-Rica-e3ff6960-6d10-439e-bc07-1967c400c9b9_thumbnail.1543970140.jpg',
            },
        ],
        state: 'CR',
        imageUrl: 'images/venues/15339/Riu-Palace-Costa-Rica-Sardinal-de-Carrillo-Costa-Rica-e3ff6960-6d10-439e-bc07-1967c400c9b9_thumbnail.1543970140.jpg',
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        // fetch the lat and long from https://www.latlong.net/place/san-jos-costa-rica-15149.html
        latitude: 9.934739,
        longitude: -84.087502,
    },
    {
        market: 'Anguilla',
        regions: [
            {
                name: 'Anguilla',
                imageUrl:null
            },
        ],
        state: 'AI',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 18.220554,
        longitude: -63.068615,
    },
    {
        market: 'Antigua and Barbuda',
        regions: [
            {
                name: 'Antigua and Barbuda',
                imageUrl:null
            },
        ],
        state: 'AG',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        latitude: 17.060816,
        longitude: -61.796429,
    },
    {
        market: 'Aruba',
        regions: [
            {
                name: 'Aruba',
                imageUrl:null
            },
        ],
        state: 'AW',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        latitude: 12.521110,
        longitude: -69.968338,
    },
    {
        market: 'Bahamas',
        regions: [
            {
                name: 'Bahamas',
                imageUrl:null
            },
        ],
        state: 'BS',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        latitude: 25.034281,
        longitude: -77.396278,
    },
    {
        market: 'Barbados',
        regions: [
            {
                name: 'Barbados',
                imageUrl:null
            },
        ],
        state: 'BB',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        latitude: 13.193887,
        longitude: -59.543198,
    },
    {
        market: 'Bermuda',
        regions: [
            {
                name: 'Bermuda',
                imageUrl:null
            },
        ],
        state: 'BM',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',

        latitude: 32.307800,
        longitude: -64.750504,
    },
    {
        market: 'Cayman Islands',
        regions: [
            {
                name: 'Cayman Islands',
                imageUrl:null
            },
        ],
        state: 'C-KY',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        latitude: 19.313299,
        longitude: -81.254601,
    },
    {
        market: 'Curacao',
        regions: [
            {
                name: 'Curacao',
                imageUrl:null
            },
        ],
        state: 'CW',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        latitude: 12.121610,
        longitude: -68.949417,
    },
    {
        market: 'Dominican Republic',
        regions: [
            {
                name: 'Dominican Republic',
                imageUrl:null
            },
        ],
        state: 'DO',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        latitude: 18.735693,
        longitude: -70.162651,
    },
    {
        market: 'Haiti',
        regions: [
            {
                name: 'Haiti',
                imageUrl:null
            },
        ],
        state: 'HT',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        latitude: 18.971188,
        longitude: -72.285217,
    },
    {
        market: 'Jamaica',
        regions: [
            {
                name: 'Jamaica',
                imageUrl:null
            },
        ],
        state: 'JM',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        latitude: 18.109581,
        longitude: -77.297508,
    },
    {
        market: 'Puerto Rico',
        regions: [
            {
                name: 'Puerto Rico',
                imageUrl:null
            },
        ],
        state: 'C-PR',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        latitude: 18.220833,
        longitude: -66.590149,
    },
    {
        market: 'Saint Kitts and Nevis',
        regions: [
            {
                name: 'Saint Kitts and Nevis',
                imageUrl:null
            },
        ],
        state: 'KN',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        latitude: 17.296450,
        longitude: -62.735771,
    },
    {
        market: 'Saint Martin',
        regions: [
            {
                name: 'Saint Martin',
                imageUrl:null
            },
        ],
        state: 'MF',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        latitude: 18.069000,
        longitude: -63.085239,
    },
    {
        market: 'Trinidad and Tobago',
        regions: [
            {
                name: 'Trinidad and Tobago',
                imageUrl:null
            },
        ],
        state: 'TT',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        latitude: 10.691803,
        longitude: -61.222504,
    },
    {
        market: 'US Virgin Islands',
        regions: [
            {
                name: 'US Virgin Islands',
                imageUrl:null
            },
        ],
        state: 'C-VI',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        latitude: 18.335766,
        longitude: -64.896332,
    },
    {
        market: 'Saint Vincent and The Grenadines',
        regions: [
            {
                name: 'Saint Vincent and The Grenadiness',
                imageUrl:null
            },
        ],
        state: 'VC',
        imageUrl: null,
        imageUrlRoot: 'https://cdn.wedding-spot.com/',
        
        latitude: 13.012296,
        longitude: -61.227730,
    }
];
